import { createFileRoute, useParams } from '@tanstack/react-router';
import { PeriodDetailPage } from '@/features/foodcost/PeriodDetailPage';

export const Route = createFileRoute('/_app/foodcost/$periodoId')({ component: Detail });

function Detail() {
  const { periodoId } = useParams({ from: '/_app/foodcost/$periodoId' });
  return <PeriodDetailPage periodoId={periodoId} />;
}
